<div class="flex-1 flex flex-col">
  <div
    *times="config.count; let rowIndex = index"
    class="flex"
    [class.flex-row]="config.direction != 'row'"
    [class.flex-col]="config.direction === 'column'"
  >
    <pms-skeleton-loader
      *times="config.cells.length; let cellIndex = index"
      [theme]="getCellTheme(config.cells[cellIndex])"
      [class.flex-1]="config.cells[cellIndex].flex !== 'unset'"
    ></pms-skeleton-loader>
  </div>
</div>
